import React from 'react';

const BrandLogo = ({ className = '', compact = false }) => (
  <div className={`inline-flex items-center gap-3 ${className}`}>
    <span
      className={`${compact ? 'h-8 w-8 text-xs' : 'h-10 w-10 text-sm'} grid place-items-center rounded-xl bg-indigo-600 font-bold tracking-tight text-white shadow-sm`}
      aria-hidden="true"
    >
      PM
    </span>
    <span className={`${compact ? 'text-xl' : 'text-2xl'} font-bold tracking-tight text-gray-900`}>
      PracticeMeter
    </span>
  </div>
);

export default BrandLogo;
